import loading from "./modules/loading"

const getters = {
    loading: state => state.loading.loading,
    menuList: state => state.menu.list
}

export default getters